import { render, staticRenderFns } from "./ShippingMethods.vue?vue&type=template&id=0f547d9a&scoped=true&"
import script from "./ShippingMethods.vue?vue&type=script&lang=js&"
export * from "./ShippingMethods.vue?vue&type=script&lang=js&"
import style0 from "./ShippingMethods.vue?vue&type=style&index=0&id=0f547d9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f547d9a",
  null
  
)

export default component.exports